import React, {Component, Fragment} from 'react';

import OitPicker from "../../../shared/forms/OitPicker";
import {withRouter} from "react-router-dom";
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import oitsActionCreators from "../../store/oits/action-creators/oits";
import {connect} from "react-redux";
import './PackagerPage.scss'
import {ApiGetRaw, ApiPost} from "../../../shared/services/api-service";
import departmentSettingsSelectors from "../../store/department-settings/selectors";

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope,'all'));
    },
  }
}

let intervalGetPackages = null

class PackagerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOitGuid: '',
      currentPackages: [],
      isPackaging: false
    }
  }

  get isLoading() {
    return !this.props.oits;
  }

  get selectedOit() {
    return this.props.oits
      && this.props.oits.find(o => o.guid === this.state.selectedOitGuid);
  }

  get currentPackages() {
    return this.state.currentPackages.filter(pack => pack.url)
  }

  componentDidMount() {
    this.props.loadOitsContainer();
  }

  generatePackage() {
    this.setState({
      isPackaging: true
    });
    ApiPost('/api/v1/training-tracker-packager', {
      trainingTrackerGuid: this.selectedOit.trainingTracker.trainingTrackerGuid
    })
      .then(() => {
        if (!(this.state.currentPackages && this.state.currentPackages.length)) {
          this.getCurrentPackage()
        } else {
          this.setState({
            currentPackages: []
          });
        }
      })
      .catch(() => {
        this.setState({
          isPackaging: false
        });
      })
  }

  getCurrentPackage() {
    return ApiGetRaw('/api/v1/training-tracker-packager/' + this.selectedOit.trainingTracker.trainingTrackerGuid)
      .then(data => {
        this.setState({
          currentPackages: data,
          isPackaging: this.state.isPackaging ? !data.length : this.state.isPackaging
        })
      })
  }

  onSelectOit(val) {
    this.setState({
      selectedOitGuid: val,
      currentPackages: [],
      isPackaging: false
    });

    clearInterval(intervalGetPackages);
    setTimeout(() => {
      this.getCurrentPackage()
    });

    intervalGetPackages = setInterval(() => {
      this.getCurrentPackage()
    }, 10000)
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {!this.isLoading && (
          <Fragment>
            <div className="app-content-header">
              <h4 className="title">EXPORT {this.props.oitShortLabel} DATA</h4>
            </div>
            <div className="app-content packager">
              <div className="packager-header">
                <div className="oit-select">
                  <OitPicker value={this.state.selectedOitGuid} onChange={(val) => this.onSelectOit(val)}/>
                </div>
                <button className="button primary" onClick={() => this.generatePackage()}>
                  <i className="fa fa-plus"/>
                  GENERATE DATA PACKAGE
                </button>
              </div>
              {this.currentPackages.map((pack) => (
                <div className="current-packages" key={pack.name}>
                  <a href={pack.url} target="_blank" download>{pack.name}</a>
                </div>
              ))}

              {!this.currentPackages.length && this.selectedOit && this.state.isPackaging && (
                <div className="text-center packaging-in-progress">Packaging in progress. The download links will appear
                  as soon as data for download is ready</div>
              )}

            </div>
          </Fragment>
        )}
      </LoadingOverlay>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(PackagerPage));
